/**Input types */
const INPUTPOINTS = 'InputPoints';
const INPUTCHECKBOX = 'InputCheckbox';
const INPUTNUMBER = 'InputNumber';
const INPUTTEXT = 'InputText';
const INPUTRADIO = 'InputRadio';
const INPUTTABLE = 'InputTable';
const INPUTVISIONTABLEA = 'InputVisionTableA';
const INPUTVISIONTABLEB = 'InputVisionTableB';
const INPUTDATE = 'InputDate';
const INPUTFILE = 'InputFile';
const TEXTFIELD = 'TextField';
const DIVIDERFIELD = 'DividerField';




/**Survey status */
const UNSIGNED = 'unsigned';
const SIGNED = 'signed';

export default {
	QUESTION: {
		TYPES: {
			INPUTPOINTS,
			INPUTCHECKBOX,
			INPUTNUMBER,
			INPUTTEXT,
			INPUTRADIO,
      INPUTTABLE,
      INPUTVISIONTABLEA,
      INPUTVISIONTABLEB,
      INPUTDATE,
      INPUTFILE,
      TEXTFIELD,
      DIVIDERFIELD,
		},
	},
	STATUS: {
		UNSIGNED,
		SIGNED,
	},
};
